import { Navigate, useSearchParams } from 'react-router-dom';
import Page from '../../components-ui/page';
import { usePermission } from '../../hooks/usePermission';
import CompactDashboard from './CompactDashboard';
import './dashboard.css';

// Types retained for chart components; Dashboard no longer supplies demo datasets.
export interface RegistrationData {month:string;registrations:number;}
export interface GradeDistributionData {grade:string;count:number;}
export interface AdmissionBatchData {batch:string;studentCount:number;}
export interface SemesterData {semester:string;averageGrade:number;}

export const CandidateStatisticsRedirect=()=> <Navigate to="/Dashboard?view=thi-sinh" replace/>;
export const LearnerStatisticsRedirect=()=> <Navigate to="/Dashboard?view=hoc-vien" replace/>;

export default function HomePage(){
    const [params,setParams]=useSearchParams();
    const {hasMenuAccess}=usePermission();
    const canCandidates=hasMenuAccess('BSKT_THONGKE_THISINH','/thong-ke-thi-sinh-bskt');
    const canLearners=hasMenuAccess('BSKT_THONGKE_HOCVIEN','/thong-ke-hoc-vien-bskt');
    const requested=params.get('view');
    const mode=requested==='hoc-vien' && canLearners ? 'learner' : canCandidates ? 'candidate' : 'learner';
    if(!canCandidates&&!canLearners)return <Page title="Dashboard"><div className="alert alert-warning" role="alert">Tài khoản chưa có quyền xem thống kê thí sinh hoặc học viên.</div></Page>;
    return <Page title="Dashboard — Học bổ sung kiến thức">
        <CompactDashboard mode={mode} tabs={
            <div className="dashboard-tabs" role="tablist" aria-label="Thống kê Dashboard">
                {canCandidates&&<button type="button" id="dashboard-candidate-tab" role="tab" aria-selected={mode==='candidate'} aria-controls="dashboard-data-panel" className={mode==='candidate'?'active':''} onClick={()=>setParams({view:'thi-sinh'},{replace:true})}><i className="bi bi-person-lines-fill" aria-hidden="true"/>Thí sinh</button>}
                {canLearners&&<button type="button" id="dashboard-learner-tab" role="tab" aria-selected={mode==='learner'} aria-controls="dashboard-data-panel" className={mode==='learner'?'active':''} onClick={()=>setParams({view:'hoc-vien'},{replace:true})}><i className="bi bi-mortarboard" aria-hidden="true"/>Học viên</button>}
            </div>
        }/>
    </Page>;
}
